/* Annie's Ibiza — Customer Care behaviour. No dependencies. */
(function () {
  'use strict';
  if (window.__acCareInit) return;
  window.__acCareInit = true;

  var mq = window.matchMedia('(max-width: 989px)');
  var norm = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim(); };
  var words = function (s) { return norm(s).split(' ').filter(function (w) { return w.length > 1; }); };
  var matches = function (text, q) {
    var t = norm(text); var ws = words(q);
    if (!ws.length) return true;
    return ws.every(function (w) { return t.indexOf(w) !== -1 || (w.length > 4 && t.indexOf(w.slice(0, -1)) !== -1); });
  };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Mobile placeholders */
  function placeholders() {
    qsa('[data-placeholder-mobile]').forEach(function (input) {
      if (!input.dataset.placeholderDesktop) input.dataset.placeholderDesktop = input.placeholder;
      var m = input.dataset.placeholderMobile;
      input.placeholder = mq.matches && m ? m : input.dataset.placeholderDesktop;
    });
  }

  /* Care tabs: keep the active tab in view */
  function tabs() {
    qsa('.ac-tabs').forEach(function (nav) {
      var active = nav.querySelector('.is-active');
      if (active) nav.scrollLeft = Math.max(0, active.offsetLeft - (nav.clientWidth - active.offsetWidth) / 2);
    });
  }

  /* "On this page" select (mobile) */
  function jump() {
    qsa('[data-ac-jump-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var el = sel.value && document.querySelector(sel.value);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        sel.selectedIndex = 0;
      });
    });
  }

  /* Country check (Delivery) */
  function country() {
    qsa('[data-ac-country]').forEach(function (box) {
      var sel = box.querySelector('[data-ac-country-select]');
      var out = box.querySelector('[data-ac-country-result]');
      var eu = (box.dataset.europe || '').split(',');
      sel.addEventListener('change', function () {
        var code = sel.value;
        if (!code) { out.hidden = true; return; }
        var msg = code === 'GB' ? box.dataset.msgUk : code === 'US' ? box.dataset.msgUs : eu.indexOf(code) !== -1 ? box.dataset.msgEurope : box.dataset.msgRow;
        out.querySelector('span').textContent = msg;
        out.hidden = false;
      });
    });
  }

  /* Hub search with suggestions */
  function hubSearch() {
    qsa('[data-ac-search]').forEach(function (box) {
      var input = box.querySelector('input[type="search"]');
      var panel = box.querySelector('[data-ac-suggest]');
      var list = box.querySelector('[data-ac-suggest-list]');
      var label = box.querySelector('[data-ac-suggest-label]');
      var all = box.querySelector('[data-ac-suggest-all]');
      var termEl = box.querySelector('[data-ac-suggest-term]');
      var cancel = box.querySelector('[data-ac-search-cancel]');
      var faqUrl = box.dataset.faqUrl || '/pages/faqs';
      if (!input || !panel) return;

      // Add the hub's topic questions to the searchable list (hidden until they match).
      var seen = {};
      qsa('[data-ac-suggest-item]', list).forEach(function (li) { seen[norm(li.textContent)] = true; li.dataset.popular = '1'; });
      qsa('[data-ac-index]').forEach(function (a) {
        var key = norm(a.textContent); if (seen[key]) return; seen[key] = true;
        var li = list.firstElementChild ? list.firstElementChild.cloneNode(true) : null;
        if (!li) return;
        var link = li.querySelector('a'); link.href = a.getAttribute('href');
        link.querySelector('span').textContent = a.textContent.trim();
        li.hidden = true; li.dataset.popular = '';
        list.appendChild(li);
      });

      function open() {
        panel.hidden = false; input.setAttribute('aria-expanded', 'true');
        if (mq.matches) { box.classList.add('is-open'); document.documentElement.classList.add('ac-lock'); }
        filter();
      }
      function close() {
        panel.hidden = true; input.setAttribute('aria-expanded', 'false');
        box.classList.remove('is-open'); document.documentElement.classList.remove('ac-lock');
      }
      function filter() {
        var q = input.value.trim(); var shown = 0;
        qsa('[data-ac-suggest-item]', list).forEach(function (li) {
          var show = q ? matches(li.textContent, q) : li.dataset.popular === '1';
          if (q && show && shown >= 6) show = false;
          li.hidden = !show; if (show) shown++;
        });
        if (label) label.hidden = !!q;
        if (all) {
          all.hidden = !q; if (termEl) termEl.textContent = q;
          all.href = faqUrl + (faqUrl.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(q);
        }
      }
      input.addEventListener('focus', open);
      input.addEventListener('input', filter);
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); input.blur(); } });
      if (cancel) cancel.addEventListener('click', function () { input.value = ''; close(); });
      document.addEventListener('click', function (e) { if (!mq.matches && !box.contains(e.target)) close(); });
      box.addEventListener('focusout', function (e) { if (!mq.matches && e.relatedTarget && !box.contains(e.relatedTarget)) close(); });
    });
  }

  /* FAQs: grouping, "View all", topic filter, search */
  function faqs() {
    var tools = document.querySelector('[data-ac-faq-tools]');
    var groups = qsa('[data-ac-faq-group]');
    if (!groups.length) return;
    var byKey = {};
    groups.forEach(function (g) { byKey[g.dataset.acFaqGroup] = g; });
    qsa('[data-ac-faq]').forEach(function (item) {
      var g = byKey[item.dataset.cat];
      if (g) g.querySelector('[data-ac-faq-items]').appendChild(item);
    });

    groups.forEach(function (g) {
      var items = qsa('[data-ac-faq]', g); var limit = parseInt(g.dataset.visible || '4', 10);
      if (mq.matches) limit = Math.min(limit, 3);
      if (items.length > limit) {
        items.slice(limit).forEach(function (i) { i.classList.add('is-collapsed'); });
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'ac-textlink ac-faq-more';
        var lbl = (mq.matches && g.dataset.moreLabelMobile ? g.dataset.moreLabelMobile : g.dataset.moreLabel) || 'View all {count}';
        btn.innerHTML = lbl.replace('{count}', items.length) + ' <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h15M14 7l5 5-5 5"/></svg>';
        btn.addEventListener('click', function () { items.forEach(function (i) { i.classList.remove('is-collapsed'); }); btn.remove(); });
        g.appendChild(btn); g._more = btn;
      }
    });

    if (!tools) return;
    var input = tools.querySelector('[data-ac-faq-input]');
    var chips = qsa('[data-ac-faq-filter] button', tools);
    var empty = tools.querySelector('[data-ac-noresults]');
    var termEl = tools.querySelector('[data-ac-noresults-term]');
    var cat = '';

    function apply() {
      var q = input ? input.value.trim() : '';
      var searching = !!q || !!cat; var total = 0;
      groups.forEach(function (g) {
        var inCat = !cat || g.dataset.acFaqGroup === cat; var n = 0;
        qsa('[data-ac-faq]', g).forEach(function (i) {
          var hit = inCat && (!q || matches(i.textContent, q));
          i.classList.toggle('is-filtered', !hit);
          if (searching) i.classList.remove('is-collapsed');
          if (hit) n++;
        });
        g.classList.toggle('is-empty', n === 0);
        if (g._more) g._more.hidden = searching;
        total += n;
      });
      if (!searching) groups.forEach(function (g) {
        if (!g._more || !g._more.isConnected) return;
        var limit = parseInt(g.dataset.visible || '4', 10); if (mq.matches) limit = Math.min(limit, 3);
        qsa('[data-ac-faq]', g).forEach(function (i, idx) { i.classList.toggle('is-collapsed', idx >= limit); });
      });
      if (empty) { empty.hidden = total > 0; if (termEl) termEl.textContent = q; }
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        cat = c.dataset.cat || '';
        chips.forEach(function (x) { var on = x === c; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        apply();
      });
    });
    if (input) {
      var t; input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(apply, 120); });
      var params = new URLSearchParams(location.search);
      if (params.get('q')) { input.value = params.get('q'); apply(); }
      var topic = params.get('topic');
      if (topic) chips.forEach(function (c) { if (c.dataset.cat === topic) c.click(); });
    }
  }

  /* Open a linked FAQ/accordion (#question-id) */
  function openHash() {
    if (!location.hash) return;
    var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (el && el.tagName === 'DETAILS') { el.classList.remove('is-collapsed', 'is-filtered'); el.open = true; el.scrollIntoView({ block: 'start' }); }
  }

  /* Size & Fit: region highlight, units, tabs */
  function sizeGuide() {
    qsa('[data-ac-sizes]').forEach(function (box) {
      var sel = box.querySelector('[data-ac-region]');
      if (!sel) return;
      sel.addEventListener('change', function () {
        qsa('tr[data-region]', box).forEach(function (tr) { tr.classList.toggle('is-highlight', tr.dataset.region === sel.value); });
      });
    });
    qsa('[data-ac-units]').forEach(function (box) {
      qsa('[data-ac-unit]', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var u = b.dataset.acUnit;
          qsa('[data-ac-unit]', box).forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          qsa('[data-ac-unit-panel]', box).forEach(function (p) { p.hidden = p.dataset.acUnitPanel !== u; });
        });
      });
    });
    qsa('[data-ac-guide-tabs]').forEach(function (nav) {
      var links = qsa('a', nav);
      var targets = links.map(function (a) { return document.querySelector(a.getAttribute('href')); });
      links.forEach(function (a, i) {
        a.addEventListener('click', function (e) {
          if (!targets[i]) return; e.preventDefault();
          targets[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', a.getAttribute('href'));
        });
      });
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var idx = targets.indexOf(en.target);
          links.forEach(function (l, j) { l.classList.toggle('is-active', j === idx); });
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      targets.forEach(function (t) { if (t) io.observe(t); });
    });
  }

  /* Returns: hide the sticky CTA when the inline buttons or footer are on screen */
  function stickyCta() {
    var bar = document.querySelector('[data-ac-sticky-cta]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var watch = qsa('.ac-band, footer, .shopify-section-group-footer-group');
    var visible = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
      bar.classList.toggle('is-hidden', visible.size > 0);
    });
    watch.forEach(function (el) { io.observe(el); });
    document.body.style.paddingBottom = mq.matches ? '80px' : '';
  }

  function init() {
    placeholders(); tabs(); jump(); country(); hubSearch(); faqs(); sizeGuide(); stickyCta(); openHash();
    if (mq.addEventListener) mq.addEventListener('change', placeholders);
    window.addEventListener('hashchange', openHash);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
